module.exports = __webpack_public_path__ + "static/media/8OLA17.6fa0c169.jpg";